import { render, staticRenderFns } from "./VideoCenter.vue?vue&type=template&id=5659907a&scoped=true"
import script from "./VideoCenter.vue?vue&type=script&lang=js"
export * from "./VideoCenter.vue?vue&type=script&lang=js"
import style0 from "./VideoCenter.vue?vue&type=style&index=0&id=5659907a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659907a",
  null
  
)

export default component.exports